
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/wishlist",
      function () {
        return require("private-next-pages/[domain]/wishlist/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[domain]/wishlist"])
      });
    }
  